<template>
  <Modal
    extra-class="dea-modal__other-role dea-modal--no-footer"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>
      Il tuo ruolo
    </template>
    <template #content>
      <div class="dea-modal__other-role-list">
        <div class="dea-modal__other-role-list-label dea-heading--medium-l">
          Sei:
        </div>
        <Checkbox
          v-for="(role, index) in rolesList"
          :id="`radio-${index}`"
          :key="index"
          class="dea-modal__other-role-list-checkbox dea-checkbox--regular"
          :checked="roleSelected === role.value"
          name="role"
          type="radio"
          :value="role.value"
          @change="switchCheckbox($event)"
        >
          <template v-if="role.value !== 'other'">
            {{ role.label }}
          </template>
          <template v-else>
            Altro: <InputText v-model="customRole" placeholder="Spiegaci di cosa ti occupi" />
          </template>
        </Checkbox>
      </div>
      <div class="dea-modal__other-role-button">
        <Buttons class="dea-button--large" :disabled="isDisabled" @click="save()">
          Salva modifiche
        </Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Checkbox from "@/components/elements/Checkbox";
import InputText from "@/components/elements/InputText";
import Modal from "@/components/patterns/Modal";

export default {
  name: "RoleModal",
  components: { Buttons, Checkbox, InputText, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customRole: "",
      rolesList: [
        {
          label: "Insegnante di scuola dell'Infanzia",
          value: "preschool-teacher",
        },
        {
          label: "Formatore/Formatrice",
          value: "trainer",
        },
        {
          label: "Studente/studentessa universitario/a",
          value: "student",
        },
        {
          label: "Docente universitario/a",
          value: "university-professor",
        },
        {
          label: "",
          value: "other",
        },
      ],
      roleSelected: "",
    };
  },
  computed: {
    isDisabled() {
      return this.roleSelected === "" || (this.roleSelected === "other" && this.customRole === "");
    },
  },
  mounted() {
    if (this.user.schoolRole !== "" && this.user.schoolRole !== " ") {
      const filtered = this.rolesList
        .filter(role => this.user.school_roles === role.label)
        .map(el => el.value)
        .join("");
      this.roleSelected = filtered !== "" ? filtered : "other";

      if (this.roleSelected === "other") {
        this.customRole = this.user.school_roles;
      }
    }
  },
  methods: {
    save() {
      let schoolRole = "";
      if (this.roleSelected === "other") {
        schoolRole = this.customRole;
      } else {
        schoolRole = this.rolesList
          .filter(role => role.value === this.roleSelected)
          .map(el => el.label)
          .join("");
      }
      this.$emit("user-update", { school_roles: schoolRole });
    },
    switchCheckbox(evt) {
      this.roleSelected = evt.target.value;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal__other-role {
  max-width: 100%;

  &-list {
    &-label {
      margin-bottom: $space-small;
    }

    &-checkbox {
      .dea-checkbox__label-wrapper {
        .dea-checkbox__label {
          display: flex;
          flex-direction: row;

          .dea-input {
            margin-left: $space-small;
            transform: translateY(-$space-x-small);
          }
        }
      }
    }
  }
}
</style>
